export interface DeltaIndicatorProps {
  /** Current score */
  current: number;
  /** Previous score (or undefined if no history) */
  previous?: number;
}

/**
 * Displays a score-change indicator arrow.
 * Green up arrow for improvement, red down arrow for decline, gray dash for unchanged.
 * Satisfies AC-10.4.
 */
export function DeltaIndicator({ current, previous }: DeltaIndicatorProps) {
  if (previous === undefined) {
    return (
      <span
        className="badge badge-info"
        data-testid="delta-indicator"
        title="No previous data"
      >
        --
      </span>
    );
  }

  const delta = current - previous;

  if (delta > 0) {
    return (
      <span
        className="badge badge-success"
        data-testid="delta-indicator"
        title={`+${delta.toFixed(1)} improvement`}
      >
        &#9650; +{delta.toFixed(1)}
      </span>
    );
  }

  if (delta < 0) {
    return (
      <span
        className="badge badge-neutral"
        data-testid="delta-indicator"
        title={`${delta.toFixed(1)} decline`}
      >
        &#9660; {delta.toFixed(1)}
      </span>
    );
  }

  return (
    <span
      className="badge"
      data-testid="delta-indicator"
      style={{ color: 'var(--genai-sem-text-muted)' }}
      title="No change"
    >
      &#8212; 0
    </span>
  );
}
